import { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  Box, Button, FormField, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useCustomFieldSet, { useCustomFieldSetForm } from '@hooks/useCustomFieldSet'

const createOrUpdateCustomFieldSet = (entityState, props, createFn) => {
  const {
    callbacks: { closeModal, createCustomFieldSet },
  } = props

  const payload = {
    callbacks: {
      action: createFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Field Set Created',
  }

  return createCustomFieldSet(payload)
}

const CreateOrEditCustomFieldSetModal = (props) => {
  const { callbacks, modalKey = 'CreateOrEditCustomFieldSetModal', showModal } = props

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { customFieldSet = {} } = modalPayload

  const newRecord = !customFieldSet.id

  const customFieldSetPayload = useCustomFieldSet(customFieldSet)
  const {
    callbacks: { createCustomFieldSet: createFn },
    creating,
    updating,
  } = customFieldSetPayload

  const formPayload = useCustomFieldSetForm(customFieldSet, { validateOn: 'change' })
  const {
    entityState,
    entityState: {
      entity_type,
    },
    handlers,
    saveEnabled,
  } = formPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title={newRecord ? 'Create' : 'Edit'} titleSecondLine="Field Set" />

      <SidebarModal.Content>
        <Box flexDirection="column">
          <FormField direction="column" label="Entity Type" marginTop="large">
            <select name="entity_type" value={entity_type} {...handlers}>
              <option value="">Please Select...</option>
              <option value="Campaign">Campaign</option>
            </select>
          </FormField>
        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating || updating}
          loadingBubbleColor="white"
          onClick={() => createOrUpdateCustomFieldSet(entityState, props, createFn)}
          size="large"
        >
          {newRecord ? 'Create Field Set' : 'Update Field Set'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

CreateOrEditCustomFieldSetModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <CreateOrEditCustomFieldSetModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
